import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageHeadingComponent} from './page-heading/page-heading.component';
import {ListSearchComponent} from './list-search/list-search.component';
import {PanelModule} from 'primeng/panel';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {GroupPartnerSelectorComponent} from './group-partner-selector/group-partner-selector.component';
import {DropdownModule} from 'primeng/dropdown';
import {SelectModule} from 'primeng/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonMenuComponent} from './button-menu/button-menu.component';
import {MenuModule} from 'primeng/menu';
import {ButtonModule} from 'primeng/button';
import {MessageModule} from 'primeng/message';
import {MessagesModule} from 'primeng/messages';
import {FilterComponent} from './filter/filter.component';
import {InputTextModule} from 'primeng/inputtext';
import {TableModule} from 'primeng/table';
import {InputSwitchModule} from 'primeng/inputswitch';
import {DatePickerModule} from 'primeng/datepicker';
import {TagModule} from 'primeng/tag';
import {InputNumberModule} from 'primeng/inputnumber';
import {ToastModule} from 'primeng/toast';
import {SelectComponent} from './filter/select/select.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ChipsModule} from 'primeng/chips';
import {FilterSaveListComponent} from './filter/filter-save-list/filter-save-list.component';
import {DialogModule} from 'primeng/dialog';
import {SimpleIframeComponent} from './simple-iframe/simple-iframe.component';
import {IframeComponent} from './iframe/iframe.component';
import {AsteriskComponent} from './asterisk/asterisk.component';
import {MultiSelectModule} from 'primeng/multiselect';
import {TasksButtonComponent} from './tasks/tasks-button.component';
import {TasksComponent} from './tasks/tasks.component';
import {TasksService} from './tasks/tasks.service';
import {SelectDatastoreComponent} from './select-datastore/select-datastore.component';
import {SelectPartnerComponent} from './select-partner/select-partner.component';
import {DisplayModule} from './field/field-display/display.module';
import {GraphSchemaModule} from './graph-schema/graph-schema.module';
import {SelectLangueComponent} from './select-langue/select-langue.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SibSmtpTemplatesComponent} from './sib-select-smtp-templates/sib-select-smtp-templates.component';
import {EditorModule} from './field/field-editor/editor.module';

import {DataFieldComponent} from './field/data-field.component';
import {FieldSelectorModeComponent} from './field/field-selector-mode/field-selector-mode.component';
import {FilterTableComponent} from './filter/filter-table/filter-table.component';
import {SelectSaveQueryComponent} from './select-save-query/select-save-query.component';
import {FilterTreeTableComponent} from './filter/filter-tree-table/filter-tree-table.component';
import {TreeTableModule} from 'primeng/treetable';
import {
    TjTreeTableCellEditorComponent
} from './filter/filter-tree-table/tj-tree-table-cell-editor/tj-tree-table-cell-editor.component';
import {FilterEditComponent} from './filter/filter-tree-table/filter-edit/filter-edit.component';
import {FilterDisplayComponent} from './filter/filter-tree-table/filter-display/filter-display.component';
import {RippleModule} from 'primeng/ripple';
import {
    TjTTEditableColumnDirective
} from './filter/filter-tree-table/tj-tteditable-column/tj-t-t-editable-column.directive';
import {DTTEditableColumnDirective} from './filter/filter-tree-table/dtteditable-column.directive';
import {FilterPresetComponent} from './filter/filter-preset/filter-preset.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DeltaDateComponent} from './filter/filter-tree-table/filter-edit/delta-date/delta-date.component';
import {TextareaModule} from 'primeng/textarea';
import {IdleWarningDialogComponent} from './idle-warning-dialog/idle-warning-dialog.component';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {SelectViewComponent} from './select-view/select-view.component';
import {SelectProductComponent} from './select-product/select-product.component';
import {SelectProviderComponent} from './select-provider/select-provider.component';
import {SelectClientComponent} from './select-client/select-client.component';
import {SelectProductsComponent} from './select-products/select-products.component';
import {SelectCompanyComponent} from './select-company/select-company.component';
import {CheckboxModule} from 'primeng/checkbox';
import {FilterHavingComponent} from './filter/filter-tree-table/filter-having/filter-having.component';
import {SharedComponentsModule} from './shared-components.module';
import {TabViewModule} from 'primeng/tabview';
import {SelectAffectedPartnersComponent} from './select-affected-partners/select-affected-partners.component';
import {SelectIconComponent} from './select-icon/select-icon.component';
import {SelectEntryPointComponent} from './select-entry-point/select-entry-point.component';
import {SelectChannelComponent} from './select-channel/select-channel.component';
import {FixedDropdownPositionDirective} from './filter/fixed-dropdown-position.directive';
import {CopyPresetToTenantComponent} from './copy-preset-to-tenant/copy-preset-to-tenant.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {TooltipModule} from 'primeng/tooltip';
import {DividerModule} from 'primeng/divider';
import {OperatorLabelAndOrComponent} from './filter/beautiful-filter/operator-label-and-or/operator-label-and-or.component';
import {SelectAirportComponent} from './select-airport/select-airport.component';
import {SelectCityComponent} from './select-city/select-city.component';
import {SelectCountryComponent} from './select-country/select-country.component';
import {SelectAirlineComponent} from './select-airline/select-airline.component';
import {EchartsModule} from './echarts/echarts.module';
import {AvatarModule} from 'primeng/avatar';
import {UserAvatarComponent} from './user-avatar/user-avatar.component';
import {PipesModule} from '../pipes/pipes.module';
import {OverlayPanelModule} from 'primeng/overlaypanel';

const exportsCmp = [
    PageHeadingComponent,
    ListSearchComponent,
    GroupPartnerSelectorComponent,
    ButtonMenuComponent,
    FilterComponent,
    SimpleIframeComponent,
    IframeComponent,
    TasksComponent,
    TasksButtonComponent,
    SelectDatastoreComponent,
    SelectPartnerComponent,
    SelectLangueComponent,
    SibSmtpTemplatesComponent,
    AsteriskComponent,
    FieldSelectorModeComponent,
    DataFieldComponent,
    FilterTableComponent,
    SelectSaveQueryComponent,
    IdleWarningDialogComponent,
    ConfirmationDialogComponent,
    FilterTreeTableComponent,
    TjTreeTableCellEditorComponent,
    FilterEditComponent,
    FilterDisplayComponent,
    TjTTEditableColumnDirective,
    DeltaDateComponent,
    DTTEditableColumnDirective,
    SelectViewComponent,
    SelectProductComponent,
    SelectProductsComponent,
    SelectProviderComponent,
    SelectClientComponent,
    SelectCompanyComponent,
    FilterPresetComponent,
    SelectAffectedPartnersComponent,
    SelectIconComponent,
    SelectComponent,
    SelectEntryPointComponent,
    SelectChannelComponent,
    FixedDropdownPositionDirective,
    SelectAirportComponent,
    SelectCityComponent,
    SelectCountryComponent,
    SelectAirlineComponent,
    UserAvatarComponent
];
@NgModule({
    declarations: [
        FilterSaveListComponent,
        ...exportsCmp,
        FilterHavingComponent,
        FilterPresetComponent,
        CopyPresetToTenantComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        PanelModule,
        BreadcrumbModule,
        DropdownModule,
        SelectModule,
        FormsModule,
        MenuModule,
        ButtonModule,
        MessageModule,
        MessagesModule,
        InputTextModule,
        InputNumberModule,
        TableModule,
        AvatarModule,
        InputSwitchModule,
        DatePickerModule,
        TagModule,
        ToastModule,
        AutoCompleteModule,
        ChipsModule,
        DialogModule,
        ReactiveFormsModule,
        MultiSelectModule,
        GraphSchemaModule,
        TreeTableModule,
        RippleModule,
        ConfirmDialogModule,
        TextareaModule,
        CheckboxModule,
        TabViewModule,
        SharedComponentsModule,
        EditorModule,
        DisplayModule,
        ProgressSpinnerModule,
        // `hasPermission` dans la barre de preset (règles de tag).
        PipesModule,
        OverlayPanelModule,
        TooltipModule,
        // Séparateur « ET » entre deux conditions de comptage (FilterHavingComponent), identique
        // à celui des conditions de filtre.
        DividerModule,
        OperatorLabelAndOrComponent,
        EchartsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
            isolate: false,
        }),
    ],
    exports: [
        ...exportsCmp,
        DisplayModule,
        EditorModule,
        SharedComponentsModule,
        GraphSchemaModule,
        EchartsModule,
        FilterHavingComponent
    ],
    providers: [
        [{ provide: TasksService, useValue: (window as any).tasksService }]
    ]
})
export class ComponentsModule {
}
